// extracted by mini-css-extract-plugin
module.exports = {"small":"heading-with-count_small__2VFYz"};